import React from 'react';

const Spinner = ({ spinex }) => (
  <div className="spinner-container">
    <div className={spinex ? 'spinex' : 'spinner'} />
  </div>
);

export default Spinner;
